import type React from 'react';

export const ConveniatLogo: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="a">
          <path d="M43.622 28.452h79.999v-80H43.622z" />
        </clipPath>
        <clipPath id="b">
          <path d="M43.622 40.879h79.999v-80H43.622z" />
        </clipPath>
        <clipPath id="c">
          <path d="M-40.148 19.497h79.999v-80h-79.999z" />
        </clipPath>
        <clipPath id="d">
          <path d="M-62.89 39.092h79.999v-80H-62.89z" />
        </clipPath>
        <clipPath id="e">
          <path d="M-5.119 53.286h80v-80h-80z" />
        </clipPath>
        <clipPath id="f">
          <path d="M-74.99 28.652H5.009v-80H-74.99z" />
        </clipPath>
        <clipPath id="g">
          <path d="M-74.868 51.248H5.131v-80h-79.999z" />
        </clipPath>
      </defs>
      <circle cx={37.5} cy={37.5} r={37.5} fill="#fff" />
      <g transform="translate(-.134 -.578) scale(1.0036)">
        <path
          fill="#e30613"
          d="M0 0c2.647-.01 5.295-.029 7.942-.029 15.926-.002 31.851-.053 47.775.045 3.298.021 6.615.458 9.881.968 2.358.368 4.531.321 6.591-.95 2.712-1.672 5.421-3.347 8.316-5.135-.544-.325-.899-.59-1.294-.766-5.293-2.356-10.836-3.911-16.587-4.413-4.993-.435-10.025-.548-15.041-.572-14.887-.07-29.775-.028-44.663-.022-.973 0-1.947.06-2.92.092z"
          clipPath="url(#a)"
          transform="matrix(.89723 0 0 -.89723 -37.53 27.58)"
        />
        <path
          fill="#e30613"
          d="M0 0c18.512.048 37.025.143 55.537.116 6.23-.009 12.369-.942 18.305-2.905 2.129-.704 4.181-1.64 6.266-2.476.129-.052.236-.16.499-.345-3.383-1.966-6.636-3.908-9.944-5.751-1.192-.664-2.564-.786-3.91-.465-4.656 1.107-9.391 1.3-14.146 1.299-17.143-.005-34.286-.008-51.429-.006-.393 0-.785.076-1.178.116V0"
          clipPath="url(#b)"
          transform="matrix(.89723 0 0 -.89723 -37.53 38.728)"
        />
        <path
          fill="#e30613"
          d="M0 0c.188.229.284.427.442.526C4.793 3.252 9.467 4.918 14.674 4.58c5.819-.377 10.795-2.598 14.528-7.181 3.215-3.946 4.923-8.564 5.582-13.573.778-5.922.194-11.733-2.401-17.125-3.41-7.085-8.941-11.442-17.008-12.221-4.735-.457-9.03.762-13.11 3.028-.713.396-1.43.786-2.448 1.345.324.175.54.272.734.399 3.736 2.451 7.678 4.457 12.034 5.555.643.162 1.326.167 1.991.242 3.72.424 6.433 2.283 7.953 5.727 2.693 6.106 2.619 12.185-.501 18.11-1.228 2.332-3.202 3.997-5.749 4.792-.995.311-2.114.195-3.149.407-3.219.661-6.169 2.042-9.053 3.562C2.737-1.647 1.449-.841 0 0"
          clipPath="url(#c)"
          transform="matrix(.89723 0 0 -.89723 37.634 19.544)"
        />
        <path
          fill="#184189"
          d="M0 0c-1.442.102-2.818.098-4.158.315-3.32.539-6.634 1.125-9.927 1.805-1.447.298-2.918.704-4.236 1.351-3.374 1.656-6.827 3.148-9.964 5.295-2.346 1.605-4.882 2.974-7.455 4.192-2.057.973-4.287.778-6.525.27s-4.532-.891-6.82-1.028c-2.881-.173-5.78-.042-8.838-.042.314.664.528 1.284.873 1.821 1.79 2.785 3.864 5.304 6.734 7.07 4.03 2.48 8.386 3.388 13.093 2.969 4.413-.392 8.219-2.218 11.875-4.551 4.251-2.714 8.429-5.603 13.396-6.917 1.904-.504 3.854-.834 5.786-1.226 1.61-.327 2.722-1.355 3.556-2.659C-.96 6.082-.043 3.249 0 0"
          clipPath="url(#d)"
          transform="matrix(.89723 0 0 -.89723 58.036 37.125)"
        />
        <path
          fill="#184189"
          d="M0 0c.354.035.708.105 1.062.1C4.651.052 8.242.032 11.829-.092a10.78 10.78 0 0 0 3.213-.598c3.731-1.334 7.06-.329 10.251 1.596 2.786 1.682 5.496 3.495 8.328 5.092 5.79 3.265 12.019 5.206 18.648 5.833 1.542.146 3.079.349 4.62.513.295.032.596.005.968.005-.364-3.469-1.027-6.727-3.327-9.419-.846-.99-1.912-1.514-3.179-1.809C48.873.545 46.363.02 43.971-.825c-3.185-1.124-6.117-2.798-8.961-4.649-2.565-1.67-5.173-3.369-7.972-4.566-5.114-2.189-10.419-2.404-15.747-.526-2.908 1.024-5.376 2.752-7.465 4.92-1.539 1.597-2.71 3.548-4.045 5.34L0 0"
          clipPath="url(#e)"
          transform="matrix(.89723 0 0 -.89723 6.202 49.86)"
        />
        <path
          fill="#184189"
          d="M0 0c13.768 0 27.391-.001 41.015.001 1.277.001 2.557-.014 3.832.044.672.031.936-.176.932-.863-.018-3.013-.015-6.026.007-9.038.005-.62-.251-.76-.825-.759-13.784.03-27.569.042-41.353.064-2.045.004-1.579-.07-1.818 1.752C1.44-6.133.776-3.508.239-.867.181-.579.083-.299 0 0"
          clipPath="url(#f)"
          transform="matrix(.89723 0 0 -.89723 68.896 27.759)"
        />
        <path
          fill="#184189"
          d="M0 0c1.16 2.629 1.516 5.424 1.875 8.217.069.54.016 1.101.125 1.63.048.228.363.566.562.57 1.822.032 3.645-.009 5.468-.009 10.869-.003 21.737-.003 32.606.004 1.46.001 2.922.02 4.381.076.658.025.91-.162.902-.87a458.966 458.966 0 0 1-.004-8.859c.004-.578-.144-.786-.772-.784-10.747.031-21.493.05-32.24.043C8.704.015 4.505-.06.306-.098.225-.099.143-.047 0 0"
          clipPath="url(#g)"
          transform="matrix(.89723 0 0 -.89723 68.786 48.035)"
        />
        <circle
          cx={37.499}
          cy={-37.941}
          r={36.255}
          fill="none"
          stroke="#cfd0d2"
          strokeWidth={2.22}
          transform="scale(1 -1)"
        />
      </g>
    </svg>
  );
};
